
<template>

  <main class="component-main" :style="{'margin-top': $screen.breakpoint === 'sm' ? '0px' : '50px'}">
    <div class="bldg-construct">
      <div class="ob-header bldg-header">
        <div class="ob-img bldg-header-img">
          <img :src="weatherUrl()" />
          <h5>{{setWeatherTemp()}}˚{{$store.state.user.metric ? 'C' : 'F'}} || {{bldg.weather.humidity}}%</h5>
        </div>
        <h4>{{bldgLocale()}}</h4>
        <div class="expand-add" style="margin-right:2%;">
          <img
            style="cursor:pointer;height:25px;"
            :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${!settings ? 'gearsWhite' : 'back'}.png`"
            @click="settings = settings ? false : true"
          />
        </div>
      </div>
      <div v-for="(f, x) in aboveGround" :class="`floor ${f.status}-floor`" v-if="!settings" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: f.index})">
        <v-popover trigger="hover" placement="top-end" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: f.index})">
          <div class="floor-hoverer"></div>
          <template slot="popover">
            <hover-component :options="setToolTip(f)" style="cursor:pointer;"></hover-component>
          </template>
        </v-popover>
        <div class="floor-title">
          <h5>{{f.name}}</h5>
        </div>
        <div class="expand-add">
          <h2 v-if="f.status === 'inactive'">+</h2>
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/expandWhite.png" v-else />
        </div>
      </div>
      <div class="floor ground-floor" v-if="!settings"><h5>Ground Level</h5></div>
        <div v-for="(f, x) in belowGround" :class="`floor ${f.status}-floor`" v-if="!settings" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: f.index})">
          <v-popover offset="0" trigger="hover" placement="top-end" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: f.index})">
            <div class="floor-hoverer"></div>
            <template slot="popover">
              <hover-component :options="setToolTip(f)" style="cursor:pointer;"></hover-component>
            </template>
          </v-popover>
        <div class="floor-title">
          <h5>{{f.name}}</h5>
        </div>
        <div class="expand-add">
          <h2 v-if="f.status === 'inactive'">+</h2>
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/expandWhite.png" v-else />
        </div>
      </div>
      <settings-component v-if="settings"></settings-component>
    </div>
  </main>

</template>

<script>

import cToF from 'celsius-to-fahrenheit';

import Settings from './Settings';
import Hover from '../hover/Hover';

import Lang from '@/lib/langTemplates/BuildingTemplate';

export default {

  data(){
    return {
      // aboveGround: [],
      // belowGround: [],
      settings: false
    }
  },

  components: {
    'settings-component': Settings,
    'hover-component': Hover
  },

  computed: {
    bldg(){
      return this.$store.getters.getActiveBuilding();
    },
    aboveGround(){
      const bldg = this.$store.getters.getActiveBuilding();
      let bFloors = new Array(bldg.aboveGround).fill({});
      bFloors = bFloors.map((e, x) => {
        let floor = {index: x + 1};
        let active = bldg.floors.find(f => f.info.index === floor.index);
        floor.name = active && active.info && active.info.name ? active.info.name : `${this.clauses.floor} ${floor.index}`;
        if (floor.name.includes("Floor")) {
          floor.name = floor.name.replace(/Floor/g, this.clauses.floor);
        }
        floor.rooms = active && active.rooms && active.rooms.length ? active.rooms.length : 0;
        floor.status = setStatus(active);
        return floor;
      });
      bFloors = bFloors.reverse();
      return bFloors;
    },
    belowGround(){
      const bldg = this.$store.getters.getActiveBuilding();
      let bFloors = new Array(bldg.belowGround).fill({});
      bFloors = bFloors.map((e, x) => {
        let floor = {index: 0 - (x + 1)};
        let active = bldg.floors.find(f => f.info.index === floor.index);
        floor.name = active && active.info && active.info.name ? active.info.name : `${this.clauses.floor} ${floor.index}`;
        if (floor.name.includes("Floor")) {
          floor.name = floor.name.replace(/Floor/g, this.clauses.floor);
        }
        floor.rooms = active && active.rooms && active.rooms.length ? active.rooms.length : 0;
        floor.status = setStatus(active);
        return floor;
      });
      return bFloors;
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    weatherUrl(){
      if (this.bldg.weather) {
          return `https://openweathermap.org/img/wn/${this.bldg.weather.icon}@2x.png`
      } else {
          return ''
      }
    },

    setWeatherTemp(){
      return Math.round(this.$store.state.user.metric ? this.bldg.weather.temperature : cToF(this.bldg.weather.temperature));
    },

    bldgLocale(){
      return `${this.bldg.info.city.length < 25 ? this.bldg.info.city : this.bldg.info.city.substring(0, 22) + '...'}, ${this.bldg.info.country}`
    },

    setToolTip(floor){
      let temp = {
        type: 'mini',
        exception: true
      };
      if (floor.status !== 'inactive') {
        const thisFloor = this.bldg.floors.find(b => b.info.index == floor.index);
        switch(floor.status){
          case 'bad':
            temp.text = `<span style="color:yellow;">${thisFloor.overallAlerts.bad} Warning Alert${thisFloor.overallAlerts.bad == 1 ? '' : 's'}</span>`;
          break;
          case 'crit':
            temp.text = `<span style="color:red;display:block;">${thisFloor.overallAlerts.crit} Critical Alert${thisFloor.overallAlerts.crit == 1 ? '' : 's'}</span>`;
          break;
          default:
            temp.text = 'No Alerts'
        }
      } else {
        temp.text = 'No AirPulse Devices Installed'
      }
      return temp;
    }

  },

  mounted(){
    if (Math.floor(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    } else {
      this.$store.dispatch('setNav', ['org', 'bldg']);
      const roomCount = this.bldg.floors.reduce((a, i) => {
        if (i.rooms && i.rooms.length) a++;
        return a;
      }, 0);
      this.$store.dispatch('componentHeader', {
        type: 'bldg',
        title: this.bldg.info.name,
        lgText: roomCount,
        smText: `of ${this.bldg.aboveGround + this.bldg.belowGround} Floor${this.bldg.aboveGround + this.bldg.belowGround === 1 ? '' : 's'}<br />Monitored`,
        alerts: this.bldg.overallAlerts,
      });
      this.$store.dispatch('switchBubbles', true);
    }
  }

}

function setStatus(floor){
  if (!floor || !floor.info || !floor.rooms || !floor.rooms.length) {
    return 'inactive';
  } else {
    if (floor.rooms.every(i => i.meas === 'no data' || Object.keys(i.meas).every(k => i.meas[k] === 'no data' || i.meas[k] === '-'))) {
      return 'empty';
    } else if (floor.overallAlerts.crit > 0) {
      return 'crit';
    } else if (floor.overallAlerts.bad > 0) {
      return 'bad'
    } else {
      return 'good';
    }
  }
}

</script>

<style>

.bldg-construct {
  width: 96%;
  max-height: 98%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 2px solid rgb(0, 153, 191);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding: 5px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.bldg-header {
  min-height: 60px;
  max-height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  justify-content: space-between;
}

.bldg-header-img {
  height: 60px;
  width: 15%;
  min-width: 100px;
  border-top-left-radius: 4px;
  flex-direction: column;
  justify-content: flex-start;
}

.bldg-header-img img {
  margin: 0px;
  margin-top: -5px;
  height: 50px;
}

.bldg-header-img h5 {
  margin: 0px;
  margin-top: -7px;
}

.bldg-header h4 {
  color: rgb(0, 153, 191);
  font-weight: lighter;
}

.floor {
  width: 100%;
  min-height: 45px;
  max-height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px;
  cursor: pointer;
  position: relative;
}

.inactive-floor {
  background-color: #545457;
}

.crit-floor {
  background-color: #a82232;
}

.bad-floor {
  background-color: #c7ac4e;
}

.good-floor {
  background-color: #66ad5f;
}

.empty-floor {
  background-color: rgb(0, 153, 191);
}

.ground-floor {
  min-height: 20px;
  max-height: 20px;
  justify-content: center;
  background-color: #325468;
}

.floor-title {
  width: 46%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
}

.expand-add {
  width: 48%;
  margin-right: 2%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.expand-add img {
  height: 12px;
}

.floor-hoverer {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: none;
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/building/Building.vue